export default {
  props: {
    creative: Object,
  },
  data() {
    return {
      prefixes: ["", "moz", "webkit", "ms"],
      intervalEvent: null,
    };
  },
  methods: {
    onLoad() {
      this.loaded--;
    },
    isInViewport(elem) {
      var el = elem.getBoundingClientRect();
      var h = window.parent.innerHeight;
      var w = window.parent.innerWidth;
      var h_mid = (el.top + el.bottom) / 2;
      var w_mid = (el.left + el.right) / 2;
      if (el.bottom < 0 || el.top > h || el.right < 0 || el.left > w)
        return false;
      var h_percent = 1,
        w_percent = 1;
      if (h_mid <= 0) h_percent = el.bottom / h;
      else if (h_mid > h) h_percent = 1 - el.top / h;
      if (w_mid <= 0) w_percent = el.right / w;
      else if (w_mid > w) w_percent = 1 - el.left / w;
      return h_percent * w_percent >= 0.5;
    },
    isPageHidden() {
      return (
        document.hidden ||
        document.webkitHidden ||
        document.mozHidden ||
        document.msHidden
      );
    },
    close() {
      if (this.intervalEvent) clearInterval(this.intervalEvent);
      document.querySelector(".closebutton").parentElement.remove();
    },
    setLayout(vAlign, vPadding, hAlign, hPadding) {
      let layoutObj = {};
      let translateY = "0%";
      let translateX = "0%";

      if (vAlign && vAlign !== "center") {
        layoutObj[vAlign] = vPadding + "px";
      } else {
        layoutObj.top = "50%";
        translateY = "-50%";
      }

      if (hAlign && hAlign !== "center") {
        layoutObj[hAlign] = hPadding + "px";
      } else {
        layoutObj.left = "50%";
        translateX = "-50%";
      }

      layoutObj.transform = `translate(${translateX}, ${translateY})`;

      return layoutObj;
    },
    setStyle(e, p) {
      for (let prefix of this.prefixes) {
        if (prefix) {
          prefix = "-" + prefix + "-";
        }
        for (let key in p) {
          e.style.setProperty(prefix + key, p[key], "important");
        }
      }
    },
    addEvent(obj, evType, fn, options = false) {
      if (obj.addEventListener) {
        obj.addEventListener(evType, fn, options);
        return true;
      } else if (obj.attachEvent) {
        var r = obj.attachEvent("on" + evType, fn);
        return r;
      } else {
        return false;
      }
    },
    removeEvent(obj, evType, fn, options = false) {
      if (obj.removeEventListener) {
        obj.removeEventListener(evType, fn, options);
        return true;
      } else if (obj.detachEvent) {
        var r = obj.detachEvent("on" + evType, fn);
        return r;
      } else {
        return false;
      }
    },
    offsets(elem) {
      var docElem, win, rect, doc;
      if (!elem) {
        return;
      }
      rect = elem.getBoundingClientRect();
      if (rect.width || rect.height || elem.getClientRects().length) {
        doc = elem.ownerDocument;
        win = doc.defaultView;
        docElem = doc.documentElement;
        return rect.top + win.pageYOffset - docElem.clientTop;
      }
    },
    setBgImg(img_src, preview_device) {
      if(preview_device === CONSTANT.PREVIEW_DEVICE.MOBILE){
        let insertPosition = img_src.lastIndexOf('/');
        return img_src.slice(0, insertPosition+1) + "mobile_" + img_src.slice(insertPosition+1);
      } else{
        return img_src;
      }
    }
  },
};
